import { SingleSelect } from 'Shared/forms/Inputs';
import { LabelOnLeftWrap } from 'Shared/forms/Wrap';
import { StyleFieldsRow } from 'Shared/backend/styles/StyleFieldsRow';


export const textAlignOptions = {
	left: 'Left',
	center: 'Centre',
	right: 'Right',
};


export function TextAlign()
{
	return (
		<StyleFieldsRow>
			<TextAlignFields />
		</StyleFieldsRow>
	);
}


/* The alignment on its own, for a caller that names the location itself - see ruleProperties(). */
export function TextAlignFields()
{
	return (
		<LabelOnLeftWrap label='' narrow={true}>
			<SingleSelect field='align' options={textAlignOptions} />
		</LabelOnLeftWrap>
	);
}
